export const VARIANTS = {
    FILLED: 'filled',
    OUTLINED: 'outlined',
    CONTAINED: 'contained',
    SOFT: 'soft',
    STANDARD: 'standard',
    TEXT: 'text',
    BUFFER: 'buffer',
}

export const SIZES = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large',
}
